import { render, staticRenderFns } from "./GMResolutionPostPage.vue?vue&type=template&id=718cf4d0&scoped=true&"
import script from "./GMResolutionPostPage.vue?vue&type=script&lang=ts&"
export * from "./GMResolutionPostPage.vue?vue&type=script&lang=ts&"
import style0 from "./GMResolutionPostPage.vue?vue&type=style&index=0&id=718cf4d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718cf4d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
